(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/init.js');
"use strict";


svs.ticket_gifts.init = async () => {
  const PlayerRouter = svs.app.ReactRouter.PlayerRouter;
  const Route = svs.app.ReactRouter.Route;
  const baseUrl = svs.core.data.baseUrl;
  const ManualRedeem = svs.ticket_gifts.manualRedeem.components.ManualRedeem;
  const Redeem = svs.ticket_gifts.redeem.components.Redeem;
  const Barcode = svs.ticket_gifts.barcode.components.Barcode;
  const {
    UnavailableTicket
  } = svs.ticket_gifts.redeem.components.unavailableTicket;
  const GameLauncherWrapper = svs.ticket_gifts.redeem.components.GameLauncherWrapper;
  const AsyncRoute = svs.ticket_gifts.redeem.components.AsyncRoute;
  const giftCode = location.pathname.split('/')[2];
  const chooseGameForVoucher = svs.ticket_gifts.chooseGameForVoucher;
  const getVouchers = svs.ticket_gifts.utils.getVouchers;
  let voucherData;
  try {
    svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && (voucherData = await getVouchers(giftCode));
  } catch (e) {
    if (e.code === '26 102' || e.code === '26 3') {
      window.location.href = "".concat(svs.core.data.baseUrl, "?err=").concat(giftCode);
      return;
    }
    return svs.tur.apierrors.showErrorMessage({
      response: e.code,
      onConfirm: () => {
        window.location.href = svs.core.data.baseUrl;
      }
    });
  }
  const getActiveVouchers = (voucherData, voucherIndex, voucherCode) => [...voucherData.vouchers.slice(voucherIndex), ...voucherData.vouchers.slice(0, voucherIndex)].filter(v => v.state === 'ACTIVE' && v.voucherId !== voucherCode).sort((a, b) => Boolean(chooseGameForVoucher(b)) - Boolean(chooseGameForVoucher(a))); 

  ReactDOM.render(React.createElement(PlayerRouter, {
    basename: baseUrl,
    withRouter: true
  }, React.createElement(Route, {
    component: ManualRedeem,
    exact: true,
    path: "/"
  }), React.createElement(Route, {
    component: _ref => {
      let {
        history,
        match
      } = _ref;
      const ticketsSearchParams = svs.utils.paramHandler.get({
        key: 'tickets'
      });
      const priceSearchParams = svs.utils.paramHandler.get({
        key: 'price'
      });
      const numberOfTickets = ticketsSearchParams.key && Number(ticketsSearchParams.value) || 0;
      const totalPrice = priceSearchParams.key && Number(priceSearchParams.value) || 0;
      return React.createElement(Redeem, {
        history: history,
        isPlayer: svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER),
        match: match,
        numberOfTickets: numberOfTickets,
        totalPrice: totalPrice,
        voucherData: voucherData
      });
    },
    exact: true,
    path: "/:giftCode"
  }), React.createElement(Route, {
    component: _ref2 => {
      let {
        match,
        history
      } = _ref2;
      return React.createElement(AsyncRoute, {
        key: match.params.voucherCode,
        todo: done => {
          const {
            voucherCode
          } = match.params;
          if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
            return svs.components.customer_login.login();
          }
          const voucherIndex = _.findIndex(voucherData.vouchers, v => v.voucherId === voucherCode);
          const voucher = voucherData.vouchers[voucherIndex];
          const ticketInfo = chooseGameForVoucher(voucher);
          const skinId = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.normalizeSkinId(voucher.ticketPosition);
          const activeVouchers = getActiveVouchers(voucherData, voucherIndex, voucherCode);
          const nextVoucher = activeVouchers[0];
          const wagerId = svs.utils.paramHandler.get({
            key: 'wagerId'
          }).value;
          const onClose = e => {
            var _voucherData;
            e === null || e === void 0 || e.preventDefault();
            if (((_voucherData = voucherData) === null || _voucherData === void 0 || (_voucherData = _voucherData.vouchers) === null || _voucherData === void 0 ? void 0 : _voucherData.length) === 1) {
              window.location.href = "".concat(svs.core.urlMapping.get('myBetsHome'));
            } else {
              window.location.href = "".concat(svs.core.urlMapping.get('ticketGiftHome'), "/").concat(voucherCode);
            }
          };
          if (!ticketInfo) {
            done(() => React.createElement(UnavailableTicket, {
              history: history,
              voucher: voucher
            }));
          } else if (!wagerId || wagerId.toLowerCase() === 'PENDING') {
            voucher.state = 'CLAIMED';
            svs.utils.paramHandler.set({
              key: 'wagerId',
              value: 'PENDING'
            });
            done(() => React.createElement(GameLauncherWrapper, {
              history: history,
              match: match,
              nextVoucher: nextVoucher,
              onClose: onClose,
              receiverSameAsBuyer: voucherData.receiverSameAsBuyer,
              skinId: skinId,
              ticketInfo: ticketInfo,
              voucherCode: voucherCode
            }));
          } else {
            voucher.state = 'CLAIMED';
            done(() => React.createElement(GameLauncherWrapper, {
              history: history,
              isPurchaseDisabled: true,
              match: match,
              nextVoucher: nextVoucher,
              onClose: onClose,
              receiverSameAsBuyer: voucherData.receiverSameAsBuyer,
              ticketInfo: ticketInfo,
              wagerId: wagerId
            }));
          }
        }
      });
    },
    exact: true,
    path: "/:giftCode/spela/:voucherCode"
  }), React.createElement(Route, {
    component: _ref3 => {
      var _voucherData2;
      let {
        match: {
          params: {
            giftCode
          }
        },
        history
      } = _ref3;
      let nextVoucher = null;
      let availableOnline = false;
      const ticketsSearchParams = svs.utils.paramHandler.get({
        key: 'tickets'
      });
      const priceSearchParams = svs.utils.paramHandler.get({
        key: 'price'
      });
      const manual = svs.utils.paramHandler.get({
        key: 'manual'
      });
      svs.utils.paramHandler.remove({
        key: 'manual'
      });
      const numberOfTickets = ticketsSearchParams.key && Number(ticketsSearchParams.value) || 0;
      const totalPrice = priceSearchParams.key && Number(priceSearchParams.value) || 0;
      if ((_voucherData2 = voucherData) !== null && _voucherData2 !== void 0 && _voucherData2.vouchers) {
        var _voucherData3, _voucherData4, _voucherData5;
        const voucherIndex = _.findIndex((_voucherData3 = voucherData) === null || _voucherData3 === void 0 ? void 0 : _voucherData3.vouchers, v => v.voucherId === giftCode);
        const activeVouchers = getActiveVouchers(voucherData, voucherIndex, giftCode);
        nextVoucher = activeVouchers && activeVouchers[0];
        availableOnline = ((_voucherData4 = voucherData) === null || _voucherData4 === void 0 ? void 0 : _voucherData4.vouchers) && chooseGameForVoucher((_voucherData5 = voucherData) === null || _voucherData5 === void 0 ? void 0 : _voucherData5.vouchers[voucherIndex]);
      }
      return React.createElement(Barcode, {
        availableOnline: availableOnline,
        giftCode: giftCode,
        history: history,
        manual: Boolean(JSON.parse(manual && manual.value)),
        nextVoucher: nextVoucher,
        numberOfTickets: numberOfTickets,
        totalPrice: totalPrice
      });
    },
    exact: true,
    path: "/:giftCode/streckkod"
  })), document.getElementById('reactContainer'));
};
svs.ticket_gifts.init();

 })(window);